import { getCountryNameForISO2 } from "../../utils/country.utils";
var displayNames = new Map();
export var countryName = function (code, language) {
    var _a;
    if (!displayNames.has(language)) {
        try {
            displayNames.set(language, new Intl.DisplayNames([language], { type: 'region' }));
        }
        catch (_b) {
            displayNames.set(language, null);
        }
    }
    var upper = code.toUpperCase();
    var name;
    try {
        name = (_a = displayNames.get(language)) === null || _a === void 0 ? void 0 : _a.of(upper);
    }
    catch (_c) {
        // Intl rejects codes that are not ISO-2/UN M.49 (e.g. "DEU" from OHIP); show them as they are.
    }
    return name && name !== upper ? name : getCountryNameForISO2(code) || code;
};
